import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-offers-selection-token',
    templateUrl: './offers-selection-token.component.html',
    styleUrls: ['./offers-selection-token.component.css']
})
export class OffersSelectionTokenComponent implements OnInit {

    token: any;
    offers: any;
    vendorInfo: any;
    applicationId: number;
    selectedOfferGroup: FormGroup;
    errorGettingOffers: boolean = true;

    constructor(private route: ActivatedRoute, private connectionService: ConnectionService, public router: Router) {
        this.selectedOfferGroup = new FormGroup({
            selectedOfferControl: new FormControl()
        });
    }

    ngOnInit(): void {
        this.token = this.route.snapshot.queryParams.token;
        this.validateTokenForOffer().then(() => {
            this.getActiveOffers().then(() => {
                this.errorGettingOffers = false;
            }, () => {
                this.errorGettingOffers = true;
            });
        }, () => {
            this.errorGettingOffers = true;
        });
    }

    validateTokenForOffer() {
        return new Promise((resolve, reject) => {
            this.connectionService.postCustomRequest(
                environment.gateway + 'validateTokenForOffer', {},
                'application/json', null, 'token', this.token).subscribe(
                    (data: any) => {
                        this.applicationId = data.object.id;
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    getActiveOffers() {
        return new Promise((resolve, reject) => {
            this.connectionService.getCustomRequest(
                environment.gateway + 'application/' + this.applicationId + '/activeOffersNl',
                'application/json', null, 'token', this.token).subscribe(
                    (data: any) => {
                        this.offers = data.object;
                        this.selectedOfferGroup.controls.selectedOfferControl.setValue(data.object.offerList[0].offerId);
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    selectoffer() {
        return new Promise((resolve, reject) => {
            this.connectionService.postCustomRequest(
                environment.gateway + 'selectofferNl/' + this.applicationId + '/' + this.selectedOfferGroup.controls.selectedOfferControl.value, {},
                'application/json', null, 'token', this.token).subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/application/offerselectionbankinfotoken', { state: { applicationId: this.applicationId, token: this.token } });
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }
}
